// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.client.phoneverifier.enums.PhoneVerificationType

export enum PhoneVerificationType {
  EMAIL = 'email',
  PHONE = 'phone',
  SMS = 'sms',
}

export const PhoneVerificationType_values = [
  PhoneVerificationType.EMAIL,
  PhoneVerificationType.PHONE,
  PhoneVerificationType.SMS,
] as const;
